/* PagingAuditFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");
//const _ = require('lodash');

class PagingPolicyFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startConfigAuditPoliciesFeed(this._userSession.activeOrganization.id, this._filter, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadConfigAuditPolicyIdsForSelection(tenantId, selection);
    }

    getPolicyEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getPolicyEntitiesNameById(ids) {
        return this.getEntitiesValueByIdAsProm(ids, "name");
        // return this.getEntitiesNameById(ids);
    }

    getPolicyEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingPolicyFeed;
